<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
} from '@fortawesome/pro-regular-svg-icons';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';

library.add(
  faAngleDoubleRight,
);

export default {
  props: {
    locations: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    EsHeader,
    EsLoader,
  },
};
</script>

<template>
  <div class="document">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Recently Added Locations
          </div>
          <div class="header-subtitle">5 Most Recently Added / Updated Locations</div>
        </template>
      </es-header>
    </div>
    <div class="content">
      <es-loader v-if="this.loading"/>
      <table v-else class="table-layout--fixed">
        <tbody>
          <tr v-for="(location, index) in locations" :key="index">
            <td  class="single-row--summary">
              <span>
                {{ location.stateLocationId }} -
              </span>
              <span class="has-text-weight-bold">
                {{ location.location.name }}
              </span>
              <span class="is-italic has-text-grey">
                ({{ location.localCode }})
              </span>
              <span>{{ location.street1 }},</span>
              <span v-if="location.street2"> {{ location.street2 }},</span>
              <span>
                {{ location.city }}, {{ location.stateCode }}, {{ location.zip}}
              </span>
            </td>
            <td class="action-column">
              <router-link
                :to="{
                  name: 'locationDetails',
                  params: { id: location.stateLocationId },
                }"
              >
                <font-awesome-icon
                  title="View Profile"
                  :icon="['far', 'angle-double-right']"
                  class="fa-2x has-text-primary"
                />
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style lang="sass" scoped>
  table
    font-size: 12px
  .action-column
    width: 30px
  .single-row--summary
    overflow: hidden
    white-space: nowrap
    text-overflow: ellipsis
</style>
